function CardWrapper({ title, children }) {
  return (
    <>
      <h1 className="text-customPink text-2xl font-black text-center">{title}</h1>
      <div className="flex flex-wrap justify-center my-5">{children}</div>
    </>
  );
}
export default CardWrapper;
